import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import "./vp7200.css";

function KIOSKV() {
  const [mainImage, setMainImage] = useState("/images/kioskv/5-1.png");
  const [activeTab, setActiveTab] = useState("features");

  const thumbnails = [
    "/images/kioskv/5-1.png",
    "/images/kioskv/5-2.png",
    "/images/kioskv/5-3.png",
    "/images/kioskv/5-4.png",
    "/images/kioskv/5-5.png"
  ];
  return (
    <>
      <Header />
      <section className="vp7200-container">

        {/* LEFT SIDE */}
        <div className="vp7200-left">
          <div className="main-image">
            <img src={mainImage} alt="VP7200" />
          </div>

          {/* <div className="thumbnails">
            {thumbnails.map((img, index) => (
              <img
                key={index}
                src={img}
                alt=""
                onClick={() => setMainImage(img)}
              />
            ))}
          </div> */}
          <div className="thumbnails">

            {/* TOP ROW (2 IMAGES) */}
            <div className="thumb-row top-row">
              {thumbnails.slice(0, 3).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>

            {/* BOTTOM ROW (3 IMAGES) */}
            <div className="thumb-row bottom-row">
              {thumbnails.slice(3, 5).map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt=""
                  onClick={() => setMainImage(img)}
                />
              ))}
            </div>

          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="vp7200-right">

          {/* TOP CONTENT */}
          <div className="content-top">
            <h1>KIOSK V</h1>
            <h3>Secure All-Weather Contactless Reader</h3>

            <p>
              The Kiosk V is a robust, secure standalone contactless reader designed for unattended environments where fast, reliable tap-to-pay functionality is essential. Ideal for ATMs, payment kiosks, ticketing and other self-service applications, it delivers secure contactless acceptance, mobile wallet support and outdoor-ready protection in a sleek standalone device built for both indoor and outdoor use.
            </p>
          </div>

          {/* TABS */}
          <div className="tabs">
            <button
              className={activeTab === "features" ? "active" : ""}
              onClick={() => setActiveTab("features")}
            >
              KEY FEATURES
            </button>

            <button
              className={activeTab === "specs" ? "active" : ""}
              onClick={() => setActiveTab("specs")}
            >
              SPECIFICATIONS
            </button>
          </div>

          {/* TAB CONTENT */}
          <div className="tab-content">
            {activeTab === "features" && (
              <ul>
                <li>PCI PTS 6.X certified (SRED version only)</li>
                <li>Supports the latest Visa, Mastercard, American Express& Discover L2 kernels & extensive international kernels</li>
                <li>Supports major transit kernels like Visa, Amercian Express, Discover & Interac Transit</li>
                <li>Supports Apple VAS & Google Smart Tap, Mifare Suite & FeliCa</li>
                <li>Contactless EMV L1 & L2 certified</li>
                <li>Supports direct & remote key injection</li>
                <li>Ruggedized, water resistant product made for indoor & outdoor use</li>
              </ul>
            )}

            {activeTab === "specs" && (
              <ul>
                <li>Connectivity: USB-C, Ethernet, LTE</li>
                <li>Operating Temp: -30°C to 70°C</li>
                <li>Security: PCI PTS 6.x</li>
                <li>Ingress Protection: IP65</li>
                <li>Dimensions: Compact form factor</li>
              </ul>
            )}
          </div>
        </div>
      </section>
      <section className="vp7200-benefits">

        <div className="vp7200-benefits-container">

          {/* LEFT CONTENT */}
          <div className="benefits-left">
            <h2>Fast, secure tap-to-pay for unattended environments</h2>

            <p>
              The Kiosk V is a compact, secure, and rugged contactless payment reader built for self-service and unattended environments like ATMs, parking pay stations, EV chargers and other kiosk applications. Its small form factor, weather-resistant design, and support for the latest contactless payment technologies provide a fast and seamless customer experience while maintaining strong security standards.
            </p>

            <ul>
              <li>Contactless & Mobile Payments: Supports NFC tap payments including Apple Pay and Google Pay with the latest global kernels.</li>
              <li>Secure & Certified: PCI PTS 6.X certified with strong encryption and key management.</li>
              <li>Rugged & Weather-Ready: Built for outdoor and unattended use with IP65 ingress protection and wide temperature range.</li>
              <li>Easy Integration: Multiple interfaces like BLE, RS-232, USB and UART make it simple to integrate into existing systems.</li>
            </ul>

            {/* PAYMENT METHODS */}
            <h3 className="payment-title">Multiple Payment Methods</h3>

            <div className="payment-logos">
              <img src="/images/7200/gpay.png" alt="GPay" />
              <img src="/images/7200/mc.png" alt="Mastercard" />
              <img src="/images/7200/amex.png" alt="Amex" />
              <img src="/images/7200/visa.png" alt="Visa" />
              <img src="/images/7200/apple.png" alt="Apple Pay" />
              <img src="/images/7200/samsung.png" alt="Samsung Pay" />
              <img src="/images/7200/alipay.png" alt="Alipay" />
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="benefits-right">
            <img
              src="/images/kioskv/5-6.png"
              alt="Kiosk"
            />
          </div>
        </div>
      </section>
      <section className="vp7200-features">
        <div className="vp7200-features-container">
          <div className="feature-item">
            <img src="/images/7200/flex-connect.png" alt="Connectivity" />
            <h4>Flexible Connectivity</h4>
            <p>Integrate seamlessly into your existing infrastructure.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/secure.png" alt="Security" />
            <h4>Secure & Compliant</h4>
            <p>Protect your business and customers with advanced security.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/rugged.png" alt="Rugged" />
            <h4>Rugged & Reliable</h4>
            <p>Built to withstand tough environments and 24/7 use.</p>
          </div>

          <div className="feature-item">
            <img src="/images/7200/cust.png" alt="Customer" />
            <h4>Customer Engagement</h4>
            <p>Enhance the payment experience and drive loyalty.</p>
          </div>
        </div>
      </section>
      <section className="vp7200-specs">

        <div className="vp7200-specs-container">

          <h2 className="specs-title">Technical Specifications</h2>

          {/* ELECTRICAL */}
          <div className="spec-group">
            <div className="spec-label">ELECTRICAL</div>

            <div className="spec-content electrical">
              <div className="spec-row">
                <span>CONNECTIVITY</span>
                <p>BLE (OPTIONAL), RS232, TTL & USB</p>
              </div>

              <div className="spec-row">
                <span>ENCRYPTION</span>
                <p>AES, RSA, TDES & TRANSARMOR</p>
              </div>

              <div className="spec-row">
                <span>KEY MANAGEMENT</span>
                <p>DUKPT</p>
              </div>

              <div className="spec-row">
                <span>MTBF</span>
                <p>500,000 HOURS</p>
              </div>

              <div className="spec-row">
                <span>POWER</span>
                <p>5V VIA USB</p>
              </div>
            </div>
          </div>

          {/* ENVIRONMENTAL */}
          <div className="spec-group">
            <div className="spec-label">ENVIRONMENTAL</div>

            <div className="spec-content environmental">
                <div className="spec-row">
                <span>IMPACT RATING</span>
                <p>IK07</p>
              </div>

              <div className="spec-row">
                <span>INGRESS PROTECTION RATING</span>
                <p>IP65</p>
              </div>

              <div className="spec-row">
                <span>OPERATING HUMIDITY</span>
                <p>MAXIMUM 95% (NON-CONDENSING)</p>
              </div>

              <div className="spec-row">
                <span>OPERATING TEMPERATURE</span>
                <p>-30°C TO 70°C (MAX CHANGE OF 10°C PER/HOUR)</p>
              </div>

              <div className="spec-row">
                <span>STORAGE TEMPERATURE (SRED)</span>
                <p>-30°C TO 85°C (NON-CONDENSING)</p>
              </div>

              <div className="spec-row">
                <span>STORAGE TEMPERATURE (NON-SRED)</span>
                <p>-40°C TO 85°C (NON-CONDENSING)</p>
              </div>
            </div>
          </div>

          {/* MECHANICAL */}
          <div className="spec-group">
            <div className="spec-label">MECHANICAL</div>

            <div className="spec-content mechanical">
              <div className="spec-row">
                <span>DIMENSIONS</span>
                <p>75MM (H) X 60MM (W) X 11.2 MM (D)</p>
              </div>

              <div className="spec-row">
                <span>MEMORY</span>
                <p>FLASH 16 MB (EXTERNAL FLASH SIZE IS 16 MB)</p>
              </div>

              <div className="spec-row">
                <span>WEIGHT</span>
                <p>1.76 OZ</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default KIOSKV;